import React, { useEffect, useState } from "react";
import {
  DatePickerField,
  InputField,
  RadioGroupField,
} from "../../../../components/FormFields";
import { useStateAuthValue } from "../../../../context/Auth/AuthState";
import {
  GetRacePetBySpecieId,
  GetSpeciesPet,
} from "../../../../services/petService";
import { CustomSelect } from "../../../../components/CustomSelect";
import {
  gender_pet,
  generic_data_check_box,
  size_pet,
} from "../../../../constants/constants";
import { useFormikContext } from "formik";
import { calculateAge } from "../../../../utils/DateUtil";

const PersonalInformationProfessionalForm = ({ formModel, initialValues }) => {
  const [{ userToken }] = useStateAuthValue();
  const { setFieldValue, values, touched, errors } = useFormikContext();
  const [raceList, setRaceList] = useState([]);
  const [specieList, setSpecieList] = useState([]);
  const [isInitialLoaded, setIsInitialLoaded] = useState(false);
  const [showOtherRace, setShowOtherRace] = useState(false);
  const [raceValue, setRaceValue] = useState("");
  const [specieValue, setSpecieValue] = useState({});
  const [sizeValue, setSizeValue] = useState({});
  const otherRaceOptionUid = "fa678a6b-d349-498b-875d-aad05eb86652";
  const {
    first_name,
    age,
    race,
    customRace,
    specie,
    size,
    sex_str,
    castrated_str,
    birth_date,
    furColor,
  } = formModel;

  const getRacePetsBySpecieId = async (specieId) => {
    const res = await GetRacePetBySpecieId(specieId, userToken);
    const data = res.data;
    data.push({ id: otherRaceOptionUid, race: "Otro", speciesId: specieId });
    setRaceList(data);
  };

  const getSpeciePets = async () => {
    const res = await GetSpeciesPet(userToken);
    const data = res.data;
    setSpecieList(data);
  };

  useEffect(() => {
    getSpeciePets();
  }, []);

  useEffect(() => {
    const age = calculateAge(values[birth_date.name]);
    if (age !== null) {
      setFieldValue("age", age);
    }
  }, [values[birth_date.name]]);

  // useEffect(() => {
  //   if (initialValues) {
  //     setSpecieValue(initialValues.specie);
  //     setRaceValue(initialValues.race);
  //     setSizeValue(initialValues.size);
  //     if (initialValues?.specie) {
  //       getRacePetsBySpecieId(initialValues.specie.id);
  //     }
  //   }
  // }, [initialValues]);
  // useEffect(() => {
  //   const specie = values?.specie || initialValues?.specie;
  //   const race = values?.race || initialValues?.race;
  //   const size = values?.size || initialValues?.size;

  //   setSpecieValue(specie);
  //   setRaceValue(race);
  //   setSizeValue(size);

  //   if (specie) {
  //     getRacePetsBySpecieId(specie.id);
  //   }
  // }, [values?.specie, values?.race, values?.size]);

  useEffect(() => {
    // Solo cuando estamos editando y aún no se cargó
    if (initialValues?.specie && !isInitialLoaded) {
      setSpecieValue(initialValues.specie);
      setRaceValue(initialValues.race);
      setSizeValue(initialValues.size);
      getRacePetsBySpecieId(initialValues.specie.id);
      setIsInitialLoaded(true);
    }
  }, [initialValues, isInitialLoaded]);

  // useEffect(() => {
  //   // Mantener los valores sincronizados cuando el usuario los cambia en el form
  //   if (values?.specie) {
  //     console.log("enter values");
  //     setSpecieValue(values.specie);
  //     getRacePetsBySpecieId(values.specie.id); // opcional, si querés actualizar razas cada vez que cambia la especie
  //   }
  //   if (values?.race) setRaceValue(values.race);
  //   if (values?.size) setSizeValue(values.size);
  // }, [values]);

  useEffect(() => {
    if (values?.specie) {
      setSpecieValue(values.specie);
      getRacePetsBySpecieId(values.specie.id);
    }
  }, [values.specie]);

  useEffect(() => {
    if (values?.race) {
      setRaceValue(values.race);
      if (values.race.race === "Otro") {
        setShowOtherRace(true);
      }
    }
  }, [values.race]);

  useEffect(() => {
    if (values?.size) {
      setSizeValue(values.size);
    }
  }, [values.size]);

  return (
    <>
      <div className="header">
        <h2>Información de la mascota</h2>
      </div>
      <div className="form">
        <div>
          <InputField
            name={first_name.name}
            label={first_name.label}
            autoComplete="off"
            className="field"
            requiredField
            style={{ width: "100%" }}
          />

          <CustomSelect
            name={specie.name}
            label={specie.label}
            value={specieValue}
            data={specieList}
            setValue={(newValue) => {
              setSpecieValue(newValue);
              setFieldValue(specie.name, newValue);
            }}
            className="field"
            disabled={false}
            errorMsg={specie.requiredErrorMsg}
            displayField="species"
            onChangeEvent={(e) => {
              const id = e.target.value?.id;
              setRaceValue(null);
              getRacePetsBySpecieId(id);
              setFieldValue("race", null);
              setFieldValue("vaccines", {});
            }}
            isError={errors[specie.name] && touched[specie.name]}
          />
          <CustomSelect
            name={race.name}
            label={race.label}
            value={raceValue}
            data={raceList}
            setValue={(newValue) => {
              if (newValue !== null && newValue.race === "Otro") {
                setShowOtherRace(true);
              } else {
                setShowOtherRace(false);
              }
              setRaceValue(newValue);
              setFieldValue(race.name, newValue);
            }}
            className="field"
            disabled={raceList.length === 0}
            errorMsg={race.requiredErrorMsg}
            displayField="race"
            isError={errors[race.name] && touched[race.name]}
          />

          {showOtherRace && (
            <InputField
              name={customRace.name}
              label={customRace.label}
              autoComplete="off"
              className="field"
              requiredField
              style={{ width: "100%" }}
            />
          )}
        </div>
        <div>
          <div style={{ display: "flex" }}>
            <RadioGroupField
              name={sex_str.name}
              label={sex_str.label}
              data={gender_pet}
              className="field field--radio"
              disabled={false}
            />
            <RadioGroupField
              name={castrated_str.name}
              label={castrated_str.label}
              data={generic_data_check_box}
              className="field field--radio"
              disabled={false}
            />
          </div>
          <CustomSelect
            name={size.name}
            label={size.label}
            value={sizeValue}
            data={size_pet}
            setValue={(newValue) => {
              setSizeValue(newValue);
              setFieldValue(size.name, newValue);
            }}
            className="field"
            disabled={false}
            errorMsg={size.requiredErrorMsg}
            displayField="name"
            isError={errors[size.name] && touched[size.name]}
          />
          <InputField
            name={furColor.name}
            label={furColor.label}
            autoComplete="off"
            className="field"
            requiredField
            style={{ width: "100%" }}
          />
          <div className="detail-wrapper-two-colum">
            <DatePickerField
              name={birth_date.name}
              label={birth_date.label}
              format="dd/MM/yyyy"
              minDate={new Date(birth_date.minDate)}
              maxDate={new Date()}
              disableFuture
              views={["year", "month", "date"]}
              openTo="year"
              requiredField
            />
            <InputField
              name={age.name}
              label={age.label}
              type="number"
              className="field"
              disabled
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PersonalInformationProfessionalForm;
